import {useRef, useState, useEffect } from 'react';
import Map, { Marker, Popup } from '@vis.gl/react-mapbox';
import { HiOutlineSearch } from "react-icons/hi";
import 'mapbox-gl/dist/mapbox-gl.css';

export default function AssetMap({ rawData }) {
  const [markers, setMarkers] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [showAllAssets, setShowAllAssets] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false)
  const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;


  const mapRef = useRef();

  useEffect(() => {
    async function geocodeCities() {
      const results = await Promise.all(
        rawData.map(async (item) => {
          const resp = await fetch(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
              item.city
            )}.json?access_token=${MAPBOX_TOKEN}`
          );
          const { features } = await resp.json();
          if (features?.[0]?.center) {
            const [lng, lat] = features[0].center;
            return { ...item, lat, lng };
          } else {
            console.warn(`Skipped: ${item.city}`);
            return null;
          }
        })
      );
      console.log("Cities", results)
      setMarkers(results.filter(Boolean));
    }

    if (rawData?.length > 0 && MAPBOX_TOKEN) {
      geocodeCities();
    }
  }, [rawData, MAPBOX_TOKEN]);

  const center = markers[0]
    ? [markers[0].lng, markers[0].lat]
    : [28.9661, 41.009043]; // fallback: Istanbul



  //console.log("raw data", rawData)
  const allAssets = rawData.flatMap(entry =>
    entry.assets.split(",").map(asset => ({
      asset: asset.trim(),
      city: entry.city
    }))
  );

  const filteredAssets = allAssets.filter(assetObj =>
    assetObj.asset.toLowerCase().includes(searchQuery.toLowerCase())
  );



  return (
   <div style={{ position: 'relative', width: '100%', height: '400px' }}>

      <div
  style={{
    position: 'absolute',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    padding: '8px 12px',
    width: '300px',
        }}
      >
        <div style={{ position: 'relative' }}>
          <HiOutlineSearch
            style={{
              position: 'absolute',
              left: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#6B7280',
            }}
            size={20}
          />
          <input
            type="text"
            placeholder="Search for asset"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            style={{
              width: '100%',
              border: 'none',
              outline: 'none',
              fontSize: '14px',
              paddingLeft: '32px',
            }}
          />
          {open && searchQuery.length > 0 && (
            <div className="absolute top-full left-0 w-full max-h-60 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-md z-10 mt-1">
              {filteredAssets?.length > 0 && (
                <div>
                  {filteredAssets.map((assetObj, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        const cityData = markers.find((c) => c.city === assetObj.city);
                        if (cityData && mapRef.current) {
                          console.log("Flying to:",cityData)
                          mapRef.current.flyTo({
                            center: [cityData.lng, cityData.lat],
                            zoom: 6, 
                            duration: 1500,
                          });                          
                          setSelectedCity(cityData);
                        }
                      }}
                      className={`cursor-pointer hover:bg-gray-200 px-4 py-2 ${index < filteredAssets?.length - 1 ? "border-b border-gray-200" : ""
                        }`}
                    >
                      <p
                        className="text-base font-medium"
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {assetObj.asset}
                      </p>
                      <div className="flex space-x-1 text-sm text-gray-500">
                        <span>{assetObj.city}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>


      <Map
        ref={mapRef}
        mapboxAccessToken={MAPBOX_TOKEN}
        initialViewState={{
          longitude: center[0],
          latitude: center[1],
          zoom: 4,
        }}
        mapStyle="mapbox://styles/mapbox/light-v11"
      >
        {markers.map((city) => (
           <Marker
    key={city.name}
    longitude={city.lng}
    latitude={city.lat}
    anchor="bottom"
    onClick={(e) => {
      e.originalEvent.stopPropagation();
      setSelectedCity(city);
    }}
          >
            <div style={{ position: 'relative', cursor: 'pointer' }}>
              📍
              <span
                style={{
                  position: 'absolute',
                  top: '-20px',    
                  right: '-10px',   
                  background: 'red',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '2px 6px',
                  fontSize: '12px',
                  boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                }}
              >
                {city.count}
              </span>
    </div>
  </Marker>
        ))}

        {selectedCity && (
          <Popup
            longitude={selectedCity.lng}
            latitude={selectedCity.lat}
            anchor="top"
            onClose={() => {
              setShowAllAssets(false);
              setSelectedCity(null);
            }}
          >
            <h3 className="text-lg font-semibold mb-2">{selectedCity.name}</h3>
            <ul className="rounded-xl bg-white p-4 font-[Segoe UI] shadow-md border border-gray-200">
              {selectedCity.assets
                ?.split(", ")
                .slice(0, showAllAssets ? undefined : 3) 
                .map((asset, index) => (
                  <li
                    key={index}
                    className="py-2 px-3 mb-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors shadow-sm text-sm text-gray-800"
                  >
                    <span className="inline-block">🔹</span> {asset}
                  </li>
                ))}

              {!showAllAssets &&
                selectedCity.assets?.split(", ").length > 3 && (
                  <li
                    className="py-2 px-3 text-sm text-blue-500 italic text-center cursor-pointer hover:underline"
                    onClick={() => setShowAllAssets(true)}
                  >
                    +{selectedCity.assets.split(", ").length - 3} more
                  </li>
                )}
            </ul>
          </Popup>
        )}
      </Map>
    </div>
  );
}